import utils from 'utils'

class searchDeclarationCtrl {
  constructor($scope, httpRequest, $state) {
    $scope.toggle = false
    httpRequest
      .get_qryOrgTaxPeriod(JSON.parse(localStorage.user_info).user.currentOrgId)
      .then((res) => {
        $scope.queryParam.param.skssq = res.data.value.periodCode
        initDeclaration($scope.queryParam)
      })
    const startDate = new Date()
    startDate.setFullYear(startDate.getFullYear() - 5)
    $scope.datePickerConfig = {
      startDate,
      endDate: new Date(),
      format: 'yyyymm',
      startView: 'year',
      minView: 'year',
    }
    httpRequest.get_dictByTypeArr(['sbshzt_dm', 'is_pass']).then((res) => {
      $scope.sbshztConfig = res.data.value.sbshzt_dm
      $scope.dictData = res.data.value
    })
    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        sbztDm: '', // 审核状态
        skssq: '', // 所属期
        zsxmDm: '10101',
      },
    }
    function initDeclaration(param) {
      httpRequest.post_getSbqkInfoList(param).then((res) => {
        $scope.listData = res.data.value.list
        $scope.totalItems = res.data.value.total
        $scope.queryParam.pageNum = ++res.data.value.prePage
        $scope.queryParam.pageSize = res.data.value.pageSize
      })
    }
    $scope.queryList = function () {
      initDeclaration($scope.queryParam)
    }
    $scope.tableDropdownConfig = [
      {
        label: '详情',
        handler(item) {
          const { path } = item.mbkpz
          const fileName = `${item.skssqYearMonth}-${item.mbmc}`
          const obj = utils.encode(
            JSON.stringify({
              url: `${host.etcloudBiReport}ReportServer?reportlet=${path}&op=view&sbuuid=${item.sbuuid}&__filename__=${fileName}`,
            })
          )
          const _url = $state.href(
            'declaration.addValTaxDeclaration.searchDeclaration.detail',
            { obj },
            { reload: true }
          )
          window.open(_url, '_blank')
        },
        // showWhile() {
        // },
      },
      {
        label: '导出',
        handler(item) {
          const url = `${host.etcloudSb}manage/sbSbqk/ExportSbqkToExcel?accessToken=${localStorage.id_token}&sbuuid=${item.sbuuid}`
          window.open(url, '_blank')
        },
        showWhile(item, hasPermit) {
          return hasPermit('declaration_export')
        },
      },
    ]
    $scope.dropdown_rowhover_state = function (row, flag) {
      row.dropdowstatenhover = flag
      // 返回审核流
      if (flag && !row.stateTracksList) {
        httpRequest
          .get_getTracksByKey({ bussinessKey: row.sbuuid })
          .then((res) => {
            row.stateTracksList = res.data.value
          })
      }
      console.log(row.stateTracksList)
    }
  }
}

searchDeclarationCtrl.$inject = ['$scope', 'httpRequest', '$state']
export default searchDeclarationCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/searchDeclaration/searchDeclarationCtrl.js